import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TourGateStatusE } from "../../models/enums";

type InitialStateT = {
    initialStep: number;
    currentStep: number;
    gateStatus: TourGateStatusE;
}

const initialState: InitialStateT = {
    initialStep: 0,
    currentStep: 0,
    // Starts unknown, not free: the tour's own mount decides, and until it has, nothing else may
    // open a window on top of a welcome message that is about to appear.
    gateStatus: TourGateStatusE.Pending,
}

export const productTourSlice = createSlice({
    name: 'productTour',
    initialState,
    reducers: ({
        setInitialStep: (state, action: PayloadAction<number>) => {
            state.initialStep = action.payload;
        },
        setCurrentStep: (state, action: PayloadAction<number>) => {
            state.currentStep = action.payload;
        },
        setTourGateStatus: (state, action: PayloadAction<TourGateStatusE>) => {
            state.gateStatus = action.payload;
        },
    }),
});

export const { setInitialStep, setCurrentStep, setTourGateStatus } = productTourSlice.actions;

export default productTourSlice.reducer;
